<template>
    <loading-page-layout :loaded="loaded">
        <v-container fluid>
            <slot name="breadcrumbs">
                <breadcrumbs />
            </slot>
            <v-row>
                <v-col cols="12" md="8" class="text-center">
                    <confirmation-status :company="company" :tourlead="tourlead" />
                    <confirmation-page-buttons />
                </v-col>
                <v-col cols="12" md="4">
                    <slot name="sidebar" />
                </v-col>
            </v-row>
        </v-container>
    </loading-page-layout>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import ConfirmationStatus from '~src/components/booking/confirmationStatus.src'
    import LoadingPageLayout from '@/components/LoadingPageLayout.vue'
    import ConfirmationPageButtons from '~src/components/booking/snippets/ConfirmationPageButtons.vue'

    @Component({
        components: {ConfirmationPageButtons, LoadingPageLayout, ConfirmationStatus, Breadcrumbs},
    })
    export class ConfirmationPageLayout extends Vue {
        @Prop({required: true}) company
        @Prop({required: true}) loaded
        @Prop({required: true}) tourlead
    }

    export default ConfirmationPageLayout
</script>
